const comments = [
  {
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个平台真的太棒了！每天的爆料更新速度飞快，比微博还快，而且内容质量很高，不是那种标题党，真实度也很可靠。推荐给所有爱吃瓜的朋友！',
    likes: 238,
  },
  {
    name: '娱乐圈观察员',
    time: '5小时前',
    content: '用51吃瓜视频大半年了，从最初的网页版用到现在的APP，体验一直在提升。专题做得特别用心，每次有大事件都会有专门汇总，省得我到处翻。',
    likes: 186,
  },
  {
    name: '深夜吃瓜人',
    time: '8小时前',
    content: '界面简洁干净，没有乱七八糟的广告弹窗，这点比很多同类平台强太多了。51吃瓜官网入口也很稳定，收藏夹常驻，良心平台！',
    likes: 155,
  },
  {
    name: '八卦小能手',
    time: '12小时前',
    content: '关注51吃瓜视频网很久了，资源更新真的快，而且分类清晰，想找什么类型的吃瓜视频都很方便。APP下载也很简单，已经安利给身边所有闺蜜了。',
    likes: 127,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            吃瓜热评
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            来自51吃瓜视频用户的最新评价与反馈
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {comments.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold text-sm flex-shrink-0">
                  {item.name.charAt(0)}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-800 truncate">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
                <div className="flex items-center gap-1 text-foreground-400 text-xs flex-shrink-0">
                  <i className="ri-thumb-up-line"></i>
                  <span>{item.likes}</span>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}